/**
 * Whether the user asked the OS to reduce motion. Read once per mount —
 * decorative animations don't need to react to live preference changes.
 */
export function usePrefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  )
}
